export default __webpack_public_path__ + "static/media/star.a543f25d.svg";